import {singleSlideA11y} from "../utils/swiperA11y";

export default class BannerSlider {
    constructor() {

        let banner = document.querySelector('.banner-images');

        if (!banner) {
            return;
        }

        const swiper = banner.querySelector('.swiper-active');
        const prev = banner.querySelector(".navigation-button-prev");
        const next = banner.querySelector(".navigation-button-next");
        if (swiper) {
            new Swiper(swiper, {
                loop: true,
                slidesPerView: 1,
                grabCursor: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },
                ...singleSlideA11y,
            });
        }

    }
}
